import React from "react";

export const ModalHint = ({ children }) => (
  <legend className="modal__hint">{children}</legend>
);
